import React, { useState, useEffect } from "react";
import Cropper from "react-easy-crop";
import Popup from "./Popup";
import Dropzone from 'react-dropzone'
import PicturesCrop from "../Common/PictureLoader/PicturesCrop";
import CutFileExtension from "../Utils/CutFileExtension";

type props = {
    head?: { title: string, description?: string };
    maxSize?: number;
    getFile: (file: any) => any;
    children: any;
    allowExtensions?: string[]
}

const oneMb = 1048576; 
const pictureExtensions = ["png", "svg", "jpeg", "jpg", "tiff", "tif", "heic", "heif", "webp"];

const UploadFilePopup = ({ head, maxSize, getFile, children, allowExtensions }: props) => {
    const [isOpen, setIsOpen] = useState(false);
    const [step, setStep] = useState(1);
    const [actionButtons, setActionButtons] = useState([]);

    const [file, setFile] = useState(null);
    const [error, setError] = useState(null);
    const [maxSizeB, setMaxSizeB] = useState(2097152); //20Mb default

    useEffect(() => {
        if (maxSize) setMaxSizeB(maxSize * oneMb);
    }, [maxSize])


    const handleFile = (file) => {
        console.log(file);
        setError(null);
        if (!file[0]?.type || allowExtensions && !allowExtensions.some(type => file[0].type.match(new RegExp(allowExtensions.join("|"), "i")))) return setError("Недопустимое расширение файла");
        if (file[0].size > maxSizeB) return setError(`Размер файла не должен прeвышать ${maxSizeB / oneMb} МБ`);
        setFile(new File([file[0]], file[0].name, { type: file[0].type }));

        if (pictureExtensions.includes(file[0].type.split("/")[1])) {
            setStep(2);
        } else {
            setActionButtons([
                { name: "Подтвердить", action: () => { getFile(file); setActionButtons([]); setStep(1); setIsOpen(false); }},
                { name: "Отмена", action: () => { setFile(null); setStep(1); setActionButtons([]) }}
            ])
            setStep(3);
        }
    }


    const renderStep1 = () => (
        <div className="defaultDropZone">
            <Dropzone
                onDrop={handleFile}
                maxSize={maxSizeB}
            >
                {({ getRootProps, getInputProps }) => (
                    <div className="defaultDropZoneButton"
                        {...getRootProps()}
                    >
                        <input {...getInputProps()} />
                        <img src="../../main-images/dropZoneIcon.svg"></img>
                    </div>
                )}
            </Dropzone>

            <p className="dropZoneRules" onClick={() => { setError("Произошла ошибка") }}>
                Максимальный размер файла не более {maxSizeB / oneMb} Мб
                {/*<br></br>*/}
                {/*Допустимые расширения: .png, .jpeg*/}
            </p>
        </div>
    )

    const renderStep2 = () => (
        <PicturesCrop
            img={file}
            uploadImage={(file) => { getFile(file); setFile(null); setStep(1); setIsOpen(false)}}
            setCropActive={(bool) => {
                if (!bool) {
                    setFile(null);
                    setStep(1);
                }
            }}
            setButtonText={"Подтвердить"}
        />
    )

    const renderStep3 = () => (
        <p className="p-s d-flex gap5 align-center">{CutFileExtension(file.name)}</p>
    )

    const renderBody = () => {
        if (step === 1) return renderStep1();
        if (step === 2) return renderStep2();
        if (step === 3) return renderStep3();
    }

    return (
        <>
            {children && <div onClick={() => setIsOpen(true)}>{children}</div>}

            <Popup
                isOpen={isOpen}
                head={head || { title: "Загрузите файл" }}
                close={() => setIsOpen(false)}
                actionButtons={actionButtons}
                body={renderBody()}
                error={error}
            />
        </>
    );
}
//setError(`Произошла ошибка_${Math.random()}`)
export default UploadFilePopup;